import React from 'react';
import clsx from 'clsx';
import { Icon, Segment } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import LinkifyWrapper from './LinkifyWrapper';
import MarkdownRender from './text-editors/MarkdownRender';

const DropdownSegment = ({
  className,
  icon,
  markdown,
  messageId,
  messageText,
  raised,
}) => (
  <Segment raised={raised} secondary className={clsx('aridhia-dropdown-segment', className)}>
    {icon && (<Icon name="info circle" />)}
    {messageId && (<FormattedMessage id={messageId} />)}
    {markdown && (<MarkdownRender value={messageText} />)}
    {!markdown && messageText && (
      <LinkifyWrapper>
        {messageText}
      </LinkifyWrapper>
    )}
  </Segment>
);

export default DropdownSegment;
